// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 818) return "static/css/client.232eec80.css";
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + "df658a8a" + ".chunk.css";
};